import React from 'react'
import { LucideIcon, LucideIconName } from 'utils/lucideIcon'
import { Radio } from 'uiComponents/input'
import classNames from 'classnames'
import './optionTile.scss'

interface OptionTileProps {
    title: string
    description: string | React.ReactNode
    icon?: LucideIconName
    className?: string
    onClick: () => void
}

export const OptionTile = ({ title, description, icon, className, onClick }: OptionTileProps) => (
    <div className={classNames('option-tile', className)} onClick={onClick}>
        {icon && <LucideIcon iconName={icon} />}
        <div className="option-tile-content">
            <div className="option-tile-title">{title}</div>
            <div className="option-tile-description">{description}</div>
        </div>
        <LucideIcon iconName="ArrowRight" />
    </div>
)

interface RadioOptionTileProps extends OptionTileProps {
    checked: boolean
}

export const RadioOptionTile = ({ title, description, icon, className, checked, onClick }: RadioOptionTileProps) => (
    <div className={classNames('option-tile', className, { active: checked })} onClick={onClick}>
        <Radio checked={checked} readOnly />
        {icon && <LucideIcon iconName={icon} />}
        <div className="option-tile-content">
            <div className="option-tile-title">{title}</div>
            <div className="option-tile-description">{description}</div>
        </div>
    </div>
)
